<template>
    <section class="component" style="position: relative">
        <section class="component__header">
            <span class="component__header__title">
                Ustawienia głosowania
            </span>
        </section>
        <section class="component__body settings">
            <section class="settings__item">
                <SwitchButton :label="'Automatyczne kończenie głosowania'"
                              :isPublic="$store.state.settings.client.autoEndVotingAfterAllVoted"
                              @setIsPublic="updateAutoEndVotingAfterAllVoted" />

            </section>
        </section>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
    import SwitchButton from "../../../../BasicControls/SwitchButton.vue";
    import settingsService from "../../../../../services/settings.service";
    import SmallLoader from "../../../../BasicControls/SmallLoader.vue";

    export default {
        name: "VotingSettings",
        components: {
            SwitchButton,
            SmallLoader
        },
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            async updateAutoEndVotingAfterAllVoted(status) {
                try {
                    this.isLoading = true;
                    let data = { ...this.$store.state.settings.client };
                    data.autoEndVotingAfterAllVoted = status;

                    await this._internalUpdateData(data);
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    this.isLoading = false;
                }
            },

            async _internalUpdateData(data) {
                return await settingsService.updateClientSettings(data);
            }
        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/user-profile-component.scss";

    .settings {
        padding: 15px 10px;
    }
</style>